import { useSyncExternalStore } from 'react';
import { bannerStore } from '../store';

export function useBanner() {
  const banners = useSyncExternalStore(bannerStore.subscribe, bannerStore.get);
  return {
    banners,
  };
}
